<template>
  <base-container ref="container" :isLoading="loading">
    <el-container style="height: 100%">
      <el-aside width="220px" style="padding: 5px 10px">
        <artisan-group title="病区" border style="height: 100%">
          <el-menu
            style="height: 100%"
            :default-active="wardId"
            @select="selectRes"
          >
            <el-menu-item :index="ward.id" v-for="ward in wards" :key="ward.id">
              <i class="el-icon-menu"></i>
              <span slot="title">{{ ward.name }}</span>
            </el-menu-item>
          </el-menu>
        </artisan-group>
      </el-aside>
      <el-main style="padding: 0">
        <div class="margin-v5 align-right">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-refresh"
            @click="loadIdles"
          >
            刷新
          </el-button>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-view"
            @click="viewRecord"
          >
            查看预约记录
          </el-button>
        </div>
        <el-calendar v-model="date" ref="calendar">
          <template slot="dateCell" slot-scope="{ data }">
            <el-row style="height: 100%" type="flex" align="middle">
              <div
                class="cal-date"
                :class="data.day == currentDate ? 'cal-date-select' : ''"
              >
                {{ data.day.split("-")[2] }}
              </div>
              <div
                v-if="isCurrentMonth(data.day)"
                style="flex: 1"
                class="align-center color-gray border-left-gray border-right-gray"
              >
                <div>
                  <span class="color-success" v-if="idleMap[data.day]">
                    <b style="font-size: 17px">
                      {{ idleMap[data.day].useCount }}
                    </b>
                  </span>
                  <b v-else class="color-success" style="font-size: 17px">
                    --
                  </b>
                  <span style="font-size: 17px; margin: 0 5px">/</span>
                  <span class="color-danger" v-if="idleMap[data.day]">
                    <b style="font-size: 17px">
                      {{ idleMap[data.day].idleCount }}
                    </b>
                  </span>
                  <b v-else class="color-danger" style="font-size: 17px">
                    --
                  </b>
                </div>
                <div class="color-info" style="padding-top: 10px">
                  <span style="font-size: xx-small">已预约</span>
                  <span style="font-size: xx-small">/</span>
                  <span style="font-size: xx-small"> 总空闲</span>
                </div>
              </div>
            </el-row>
          </template>
        </el-calendar>
      </el-main>
      <el-aside width="350px" style="padding: 5px 10px">
        <el-card style="height: 100%">
          <el-row
            slot="header"
            type="flex"
            justify="space-between"
            align="middle"
          >
            <span>{{ groupName }}</span>
            <!-- <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-check"
                  @click="enterIdle"
                  plain
                >
                  保存
                </el-button> -->
          </el-row>
          <el-row
            class="padding-v5"
            type="flex"
            align="middle"
            justify="space-between"
          >
            <div class="padding-h10">医疗组</div>
            <div>
              <span
                :class="enterable ? 'bed-count-editable' : 'bed-count'"
                class="color-success"
                >总</span
              >
              <span
                :class="enterable ? 'bed-count-editable' : 'bed-count'"
                class="color-primary"
                >男</span
              >
              <span
                :class="enterable ? 'bed-count-editable' : 'bed-count'"
                class="color-danger"
                >女</span
              >
              <span class="bed-count">-</span>
            </div>
          </el-row>
          <el-tree
            :data="leaders"
            node-key="id"
            default-expand-all
            :props="props"
            :expand-on-click-node="false"
          >
            <el-row
              style="flex: 1"
              type="flex"
              align="middle"
              justify="space-between"
              slot-scope="{ node, data }"
            >
              <div
                :class="data.groupId == '0' ? 'color-danger' : 'color-primary'"
                @click="groupQueue(data, node)"
              >
                <b>{{ node.label }}</b>
                <span class="text-mini">
                  ({{ data.groupId == "0" ? "组长" : "组员" }})
                </span>
              </div>
              <div>
                <b class="color-success bed-count">
                  {{ data.idleCount || 0 }}
                  <b v-if="data.useCount" class="color-danger text-mini">
                    -{{ data.useCount }}
                  </b>
                </b>
                <b class="color-primary bed-count">
                  {{ data.manCount || 0 }}
                </b>
                <b class="color-danger bed-count">
                  {{ data.womenCount || 0 }}
                </b>
                <i
                  class="bed-count el-icon-edit color-primary"
                  @click="setDoctorIdle(data)"
                ></i>
              </div>
            </el-row>
          </el-tree>
        </el-card>
      </el-aside>
    </el-container>
    <artisan-drawer
      :title="idleDrawer.title"
      :visible.sync="idleDrawer.show"
      size="25%"
      direction="right"
      :isLoading="idleDrawer.loading"
      ref="idleDrawer"
    >
      <DoctorIdleEnter
        :date="currentDate"
        :idle="idleDrawer.idle"
        @saved="idleEnterSaved"
      ></DoctorIdleEnter>
    </artisan-drawer>
    <artisan-dialog
      :title="regDrawer.title"
      :visible.sync="regDrawer.show"
      height="75%"
      width="75%"
      :isLoading="regDrawer.loading"
      ref="drawer"
    >
      <el-row style="height: 100%">
        <el-col style="height: 100%; background-color: white" :span="16">
          <div class="padding5">
            入院日期:
            <el-date-picker
              size="mini"
              v-model="regDrawer.date"
              type="date"
              placeholder="入院日期"
              @change="loadRecords"
              :clearable="false"
            >
            </el-date-picker>
          </div>
          <el-table
            highlight-current-row
            :data="records"
            style="width: 100%"
            headerCellClassName="back-gray1"
            @row-click="rowClick"
          >
            <el-table-column
              prop="patientName"
              label="姓名"
              width="200"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="patientGender"
              label="性别"
              width="70"
              header-align="center"
              align="center"
            >
              <template slot-scope="{ row }">
                <span>{{ row.patientGender == "M" ? "男" : "女" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="patientPhone"
              label="手机号"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="patientNo"
              label="身份证号"
              header-align="center"
              align="center"
            >
            </el-table-column>
          </el-table>
        </el-col>
        <el-col style="height: 100%; padding: 0 5px" :span="8">
          <artisan-group style="height: 100%" title="入院卡信息">
            <RecordDetail :record="record"></RecordDetail>
          </artisan-group>
        </el-col>
      </el-row>
    </artisan-dialog>
    <artisan-dialog
      :title="dialog.title"
      :visible.sync="dialog.show"
      width="90%"
      height="90%"
      ref="dialog"
      :isLoading="dialog.loading"
    >
      <WardGroupQueue
        v-if="dialog.show"
        :data="leader"
        @reload="reloadData"
      ></WardGroupQueue>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { getWards, getWardGroups, getWardGroupQueues } from "@/api/bed/ward";
import { saveWardIdles, loadWardIdles } from "@/api/bed/idle";
import { loadRecordsOfWardDay, inpatient } from "@/api/bed/record";
import RecordDetail from "./RecordDetail.vue";
import WardGroupQueue from "./WardGroupQueue.vue";
import DoctorIdleEnter from "./DoctorIdleEnter.vue";
import moment from "moment";
export default {
  components: { RecordDetail, WardGroupQueue, DoctorIdleEnter },
  data() {
    return {
      loading: false,
      wards: [],
      wardId: "",
      date: Date.now(),
      idles: [],
      groups: [],
      records: [],
      record: {},
      leader: {
        memebers: [],
      },
      regDrawer: {
        show: false,
        title: "",
        loading: false,
        date: Date.now(),
      },
      idleDrawer: {
        show: false,
        title: "",
        loading: false,
        idle: {},
      },
      dialog: {
        loading: false,
        show: false,
        title: "",
      },
      idleInfo: {
        idleDate: "",
        idleCount: 0,
        manCount: 0,
        womenCount: 0,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      statusType: {
        yes: "danger",
        inpatient: "success",
      },
      props: {
        label: "name",
        children: "members",
      },
    };
  },
  computed: {
    currentDate() {
      let dateStr = moment(this.date || "").format("YYYY-MM-DD");
      return dateStr;
    },
    dateMonth() {
      let monthStr = moment(this.date || "").format("YYYY-MM");
      return monthStr;
    },
    idleMap() {
      let map = {};
      this.idles.forEach((c) => {
        if (map[c.idleDate]) {
          map[c.idleDate].idleCount += c.idleCount;
          map[c.idleDate].useCount += c.useCount;
        } else {
          map[c.idleDate] = {
            idleCount: c.idleCount,
            useCount: c.useCount,
          };
        }
      });
      return map;
    },
    warnName() {
      let ward = this.wards.find((c) => c.id == this.wardId);
      if (ward) {
        return ward.name;
      }
      return "";
    },
    groupName() {
      return `${this.warnName}(${this.currentDate})--空床设置`;
    },
    leaders() {
      let idleMap = {};
      this.idles
        .filter((c) => c.idleDate == this.currentDate)
        .forEach((f) => {
          idleMap[f.doctorId] = {
            commonCount: f.commonCount,
            manCount: f.manCount,
            womenCount: f.womenCount,
            idleCount: f.idleCount,
            useCount: f.useCount,
            wardIdleId: f.id,
          };
        });
      let leaders = [];
      this.groups.forEach((c) => {
        if (idleMap[c.id]) {
          Object.assign(c, idleMap[c.id]);
        } else {
          Object.assign(c, {
            commonCount: 0,
            manCount: 0,
            womenCount: 0,
            idleCount: 0,
            useCount: 0,
          });
        }
        if (c.groupId == "0") {
          leaders.push(c);
        }
      });
      leaders.forEach((c) => {
        c.members = this.groups.filter((g) => g.groupId == c.id);
      });
      return leaders;
    },
    enterable() {
      return this.currentDate >= moment().format("YYYY-MM-DD");
    },
  },
  watch: {
    dateMonth() {
      this.loadIdles();
    },
  },
  created() {
    getWards().then((res) => {
      this.wards = res.data.data;
      if (this.wards.length) {
        this.wardId = this.wards[0].id;
        this.loadIdles();
      }
    });
  },
  methods: {
    setDoctorIdle(data) {
      this.idleDrawer.title = `空床设置--${data.name}--${this.currentDate}`;
      this.idleDrawer.idle = data;
      this.idleDrawer.show = true;
    },
    setIdleCount(data, prop) {
      if (!this.enterable) return;
      let label = "";
      switch (prop) {
        case "idleCount":
          label = "总";
          break;
        case "manCount":
          label = "男";
          break;
        case "womenCount":
          label = "女";
          break;
      }
      this.$refs.container
        .prompt({ msg: `请输入正确的(${label})空床数!`, value: data[prop] })
        .then((val) => {
          if (!isNaN(val)) {
            const num = parseInt(val);
            if (num >= 0) {
              if (prop == "idleCount") {
                if (num >= data.useCount) {
                  if (num >= data.manCount + data.womenCount) {
                    data[prop] = num;
                  } else {
                    this.$message({
                      type: "warning",
                      message: "总空床数据不可小于男女空床数之合！",
                    });
                  }
                } else {
                  this.$message({
                    type: "warning",
                    message: "总空床数据不可小于已预约床位数！",
                  });
                  return;
                }
              } else {
                data[prop] = num;
                const total = data.manCount + data.womenCount;
                if (data.idleCount < total) {
                  data.idleCount = total;
                }
              }
            }
          }
        });
    },
    isCurrentMonth(date) {
      return this.dateMonth == moment(date).format("YYYY-MM");
    },
    selectRes(wardId) {
      this.wardId = wardId;
      this.loadIdles();
    },
    loadIdles() {
      this.loading = true;
      let start = "";
      let end = "";
      if (this.currentDate) {
        start = moment(this.date).startOf("month").format("YYYY-MM-DD");
        end = moment(this.date).endOf("month").format("YYYY-MM-DD");
      } else {
        start = moment().startOf("month").format("YYYY-MM-DD");
        end = moment().endOf("month").format("YYYY-MM-DD");
      }
      getWardGroups(this.wardId).then((res) => {
        let data = res.data.data;
        data.forEach((c) => {
          c.commonCount = 0;
          c.manCount = 0;
          c.womenCount = 0;
          c.idleCount = 0;
        });
        this.groups = data;
      });
      loadWardIdles(this.wardId, start, end)
        .then((res) => {
          this.idles = res.data.data;
          this.loading = false;
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    idleEnterSaved() {
      this.idleDrawer.show = false;
      this.loadIdles();
    },
    enterIdle() {
      let data = {
        wardId: this.wardId,
        idleDate: this.currentDate,
        idles: [],
      };
      this.leaders.forEach((c) => {
        data.idles.push({
          doctorId: c.id,
          doctorName: c.name,
          idleCount: c.idleCount,
          commonCount: c.commonCount,
          manCount: c.manCount,
          womenCount: c.womenCount,
        });
        c.members.forEach((m) => {
          data.idles.push({
            doctorId: m.id,
            doctorName: m.name,
            idleCount: m.idleCount,
            commonCount: m.commonCount,
            manCount: m.manCount,
            womenCount: m.womenCount,
          });
        });
      });
      this.$refs.container.confirm({ msg: "确认保存空闲床位数！" }).then(() => {
        saveWardIdles(data).then(() => {
          this.$message({
            type: "success",
            message: "保存成功！",
          });
          this.loadIdles();
        });
      });
    },
    viewRecord() {
      this.regDrawer.date = this.date;
      this.regDrawer.title =
        this.warnName + "--" + this.currentDate + "--预约记录";
      this.regDrawer.show = true;
      this.loadRecords();
    },
    loadRecords() {
      let date = moment(this.regDrawer.date).format("YYYY-MM-DD");
      this.regDrawer.loading = true;
      loadRecordsOfWardDay(this.wardId, date)
        .then((res) => {
          this.records = res.data.data;
          this.regDrawer.loading = false;
        })
        .catch(() => {
          this.regDrawer.loading = false;
        });
    },
    rowClick(row) {
      this.record = row;
    },
    toInpatient(row) {
      this.$refs.drawer.confirm({ msg: "确认患者已入院" }).then(() => {
        this.regDrawer.loading = true;
        inpatient(row.id)
          .then(() => {
            row.status = "inpatient";
            this.$message({ type: "success", message: "操作成功！" });
            this.regDrawer.loading = false;
          })
          .catch(() => {
            this.regDrawer.loading = false;
          });
      });
    },
    groupQueue(data, node) {
      let doctorId = data.id;
      let name = data.name;
      if (data.groupId != "0") {
        doctorId = node.parent.data.id;
        name = node.parent.data.name;
      }
      this.dialog.title = name + "医疗组队列--" + this.warnName;
      this.dialog.show = true;
      this.dialog.loading = true;
      getWardGroupQueues(this.wardId, doctorId)
        .then((res) => {
          let data = res.data.data;
          let leaderIndex = data.findIndex((c) => c.groupId == "0");
          let leader = data[leaderIndex];
          data.splice(leaderIndex, 1);
          leader.members = data;
          this.leader = leader;
          this.dialog.loading = false;
        })
        .catch(() => {
          this.dialog.loading = false;
        });
    },
    getCellClass({ row, column }) {
      if (column.property == "name") {
        if (row.groupId == "0") {
          return "color-danger text-bold";
        } else {
          return "color-primary text-bold";
        }
      } else if (column.property == "idleCount") {
        return "color-success text-bold";
      } else if (column.property == "manCount") {
        return "color-primary text-bold";
      } else if (column.property == "womenCount") {
        return "color-danger text-bold";
      }
    },
  },
};
</script>

<style scoped>
.bed-count {
  width: 30px;
  text-align: center;
  display: inline-block;
  margin-right: 10px;
}
.bed-count-editable {
  width: 30px;
  text-align: center;
  display: inline-block;
  margin-right: 10px;
  text-decoration: underline;
}
.cal-date {
  font-size: 21px;
  margin-left: 5px;
  height: 30px;
  width: 30px;
  line-height: 30px;
  text-align: center;
}
.cal-date-select {
  height: 30px;
  width: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #1989fa;
  color: white;
  border-radius: 50%;
}
</style>
